import styled from "styled-components";
import FontAwesomeIcon from "@streeteasy/design-system/deprecated/Icons/FontAwesomeIcon";

export const Wrapper = styled.div.attrs({
  role: "button",
  tabindex: 0
})`
  background-color: white;
  display: flex;
  height: auto;
  line-height: 40px;
  margin: 10px 0 0 10px;
`;

export const HeartIcon = styled(FontAwesomeIcon).attrs({
  color: "primary"
})`
  font-size: 28px;
  padding: 0;
`;

export const HeartButton = styled.button`
  background: none;
  border: none;
  outline-offset: 2px;
  padding: 0;
`;
